import { defineComponent as _defineComponent } from 'vue'
import BTextField from 'JS/components/blain-form/BTextField.vue';
import bugsnagClient from 'JS/global/bugsnag';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { MicroformCardNumberField, setUpMicroformField } from 'JS/checkout/services/CyberSourceMicroformsHelper';
import { useFormRegistration } from './form-registration';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditCardNumberField',
  props: {
	captureContext: {
		type: String,
		required: true,
	},
	currentCardImg: String,
	inlineValidationError: String,
	autofocus: Boolean,
},
  emits: ["general-error", "submit", "inline-error", "update-type"],
  setup(__props, { emit }: { emit: ({
	(event: 'general-error'): void;
	(event: 'submit'): void;
	(event: 'inline-error', message: string): void;
	(event: 'update-type', type: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props






const userHasEnteredAnyPaymentInfo = ref(false);
const inputHasValue = ref(false);
const microform = ref<Microform | null>(null);
const numberField =  ref<MicroformField | null>(null);
const microformFieldTargetEl = ref<HTMLElement | null>(null);

const microformFieldTargetClasses = computed(() => {
	if (!!props.currentCardImg) {
		return 'microform_container microform_padding-left';
	} else {
		return 'microform_container';
	}
});

const fieldContainer = ref<HTMLElement | null>(null);

function handleWrapperFocus(e: FocusEvent) {
	if (e.target !== fieldContainer.value) {
		return;
	}

	numberField.value?.focus();
}

function handleNumberFieldChange(data: MicroformFieldEventMap['change']) {
	userHasEnteredAnyPaymentInfo.value = true;
	if (!data || data.empty) {
		inputHasValue.value = false;
		emit('inline-error', 'This field is required.');
	} else if (!data.couldBeValid) {
		inputHasValue.value = true;
		emit('inline-error', 'Invalid card format.');
	} else {
		inputHasValue.value = true;
		emit('inline-error', '');
	}

	if (!data || !data.couldBeValid) {
		emit('update-type', '');
		return;
	}

	emit('update-type', data.card[0].brandedName);
}

const hasFocus = ref(false);

function handleNumberFieldFocus() {
	hasFocus.value = true;
}

function handleNumberFieldBlur() {
	if (!userHasEnteredAnyPaymentInfo.value) {
		emit('inline-error', 'This field is required.');
	}

	hasFocus.value = false;
}

function handleNumberFieldSubmit() {
	emit('submit');
}

function handleNumberFieldLoad() {
	if (props.autofocus) {
		nextTick(() => {
			numberField.value.focus();
		});
	}
}

function setUpMicroforms() {
	try {
		const flex = new Flex(props.captureContext);
		if (!flex) {
			emit('general-error');
			bugsnagClient.notify('Failed to generate CyberSource flex microform');
			return;
		}

		microform.value = flex.microform("card");

		numberField.value = setUpMicroformField(microform.value);

		numberField.value.on('change', handleNumberFieldChange);
		numberField.value.on('focus', handleNumberFieldFocus);
		numberField.value.on('blur', handleNumberFieldBlur);
		numberField.value.on('inputSubmitRequest', handleNumberFieldSubmit);
		numberField.value.on('load', handleNumberFieldLoad);

		numberField.value.load(microformFieldTargetEl.value);
	} catch (e) {
		emit('general-error');
		bugsnagClient.notify('Failed to generate CyberSource flex microform');
	}
}

function validate() {
	if (!userHasEnteredAnyPaymentInfo.value) {
		emit('inline-error', 'This field is required.');
		return 'This field is required.';
	} else if (!!props.inlineValidationError) {
		return props.inlineValidationError;
	} else {
		return true;
	}
}

function resetValidation() {
	emit('inline-error', '');
}

useFormRegistration(new MicroformCardNumberField({
	microform: () => microform.value,
	validate,
	resetValidation
}));

onMounted(() =>{
	setUpMicroforms();
});

watch(()=> props.captureContext, (newVal) => {
	setUpMicroforms();
});


return { __sfc: true,props, emit, userHasEnteredAnyPaymentInfo, inputHasValue, microform, numberField, microformFieldTargetEl, microformFieldTargetClasses, fieldContainer, handleWrapperFocus, handleNumberFieldChange, hasFocus, handleNumberFieldFocus, handleNumberFieldBlur, handleNumberFieldSubmit, handleNumberFieldLoad, setUpMicroforms, validate, resetValidation, BTextField }
}

})